import useCurrentAccount from './useCurrentAccount';
import useDeveloperOverride from './useDeveloperOverride';

export default function useFeatureFlag(flag) {
  const { account, loading } = useCurrentAccount();
  const override = useDeveloperOverride(`FEATURE_FLAG:${flag}`);
  let value;

  if (override.isOverridden) {
    value = override.value();
  } else if (!account) {
    value = false;
  } else if (account.flags.indexOf(flag) > -1) {
    value = true;
  } else {
    value = false;
  }

  return {
    enabled: !!value,
    disabled: !value,
    loading,
  };
}
